export namespace Assets {
  export const images = {
    avatar: "https://assets.iyk.app/yerin/avatar.webp",
    og: "https://assets.iyk.app/yerin/og.jpg",
    logo: "https://assets.iyk.app/yerin/logo.png",
    layoutBackground: "https://assets.iyk.app/yerin/background.webp",
    sidebarLogo: "https://assets.iyk.app/yerin/avatar.webp",
    profileBackground: "https://assets.iyk.app/yerin/background.webp",
    emptyCollectionBackground: "https://assets.iyk.app/yerin/background.webp",
    enableLocation: {
      ios: {
        step1: "https://assets.iyk.app/vf/check-in/enable_location_ios_1.png",
        step2: "https://assets.iyk.app/vf/check-in/enable_location_ios_2.png",
      },
      android: {
        step1: "https://assets.iyk.app/vf/check-in/enable_location_android.png",
      },
    },
    email: {
      logo: "https://assets.iyk.app/yerin/email-logo.png",
    },
    rouletteBaseUrl: "https://assets.iyk.app/vf/roulette",
  }

  export const videos = {
    marquee: "https://assets.iyk.app/vf/marquee.mp4",
  }

  export const documents = {
    rules: null,
    privacyPolicy: "https://assets.iyk.app/iyk-privacy-policy.pdf",
    termsOfService: "https://assets.iyk.app/iyk-terms-of-service.pdf",
    artistsPrivacyPolicy: null,
  }
}
